import React, { useMemo } from "react";
import moment from "moment";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const MonthlyAppointmentsLineChart = ({ bookings = [] }) => {
  const today = moment().startOf("day");

  const chartData = useMemo(() => {
    const days = [];

    for (let i = 29; i >= 0; i--) {
      const day = today.clone().subtract(i, "days");
      days.push({
        name: day.format("MMM D"), // e.g. Apr 1
        date: day.format("YYYY-MM-DD"),
        Appointments: 0,
      });
    }

    bookings.forEach((booking) => {
      const dateStr = moment(
        booking.selectedDateTime,
        "YYYY-MM-DD hh:mm A"
      ).format("YYYY-MM-DD");
      const match = days.find((d) => d.date === dateStr);
      if (match) match.Appointments += 1;
    });

    return days;
  }, [bookings]);

  const totalAppointments = chartData.reduce(
    (sum, d) => sum + d.Appointments,
    0
  );

  return (
    <div className="bg-drylight dark:bg-neutral-800 p-5 rounded-xl border border-border shadow">
      <h2 className="text-lg font-semibold text-redlight mb-1">Appointments</h2>
      <p className="text-xs text-text mb-3">Last 30 days</p>

      <h1 className="text-3xl font-bold text-redlight mb-2">
        {totalAppointments} booked
      </h1>

      <ResponsiveContainer width="100%" height={240}>
        <LineChart data={chartData}>
          <XAxis
            dataKey="name"
            tick={{ fontSize: 10 }}
            interval={3}
            stroke="#f87171"
          />
          <YAxis allowDecimals={false} stroke="#f87171" />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="Appointments"
            stroke="#f87171"
            strokeWidth={2}
            dot={{ r: 3 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>

      <div className="flex items-center gap-4 mt-4 text-sm text-textGray">
        <div className="flex items-center gap-1">
          <span className="w-3 h-3 bg-redlight rounded-full" />
          Appointments
        </div>
      </div>
    </div>
  );
};

export default MonthlyAppointmentsLineChart;
